import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'climb-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent { }
